import { useEffect, useMemo, useState } from 'react'
import { useCookies } from 'react-cookie'

const useEditorCredits = () => {
	const [cookies, setCookies] = useCookies(['editorCreditsConsumed'])
	const [consumed, setConsumed] = useState<number>(() => cookies.editorCreditsConsumed ?? 0)

	// Update localStorage whenever 'consumed' changes
	useEffect(() => {
		setCookies('editorCreditsConsumed', consumed)
	}, [consumed, setCookies])

	// Use functional updates to avoid stale state
	const consumeCredits = (numCredits: number) => {
		setConsumed((prev) => prev + numCredits)
	}

	const addCredits = (numCredits: number) => {
		setConsumed((prev) => prev - numCredits)
	}

	const creditsAvailable = useMemo(() => {
		return 2 - (cookies.editorCreditsConsumed ?? 0)
	}, [cookies.editorCreditsConsumed])

	return {
		creditsConsumed: consumed,
		creditsAvailable: Math.max(0, creditsAvailable),
		consumeCredits,
		addCredits,
	}
}

export default useEditorCredits
